// extracted by mini-css-extract-plugin
export default {"MainMenu":"MainPage_MainMenu__hkLxi","Logo":"MainPage_Logo__TxpIQ"};